import { render, staticRenderFns } from "./SHTableSessionCardSkeleton.vue?vue&type=template&id=11b483be&"
import script from "./SHTableSessionCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHTableSessionCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports